import React, { useState } from 'react'
import './Message.css'
import DeleteOutlinedIcon from '@mui/icons-material/DeleteOutlined';
import db from './firebase';
import { useParams } from 'react-router-dom'
import { auth, provider } from "./firebase"
import Login from './Login';


function Message({
    messages, 
    timestamp,
    user,
    userImage
}) 
{
const { roomId } = useParams()

function deleteMessage() {
// go query for the matching timestamp and message, then delete or return an error
db.collection('rooms').doc(roomId).collection('messages')
  .where('timestamp', "==", timestamp).where('messages', '==', messages).get()
  .then(querySnapshot => {
    querySnapshot.docs[0].ref.delete()
  }).catch((error) => {
    console.log('there was an error')
  })
}

// const login = (auth.currentUser == user)



return (
    <div className='message'>
        
     <img className='message__userImg' src={userImage} alt="" />  

    <div className="message__info">
        <div className="message__info-wrapper">
        <h4>
            {user} <span className='message__timestamp'>{new Date (timestamp?.toDate()).toUTCString()} </span>   
           
        </h4>
          {auth.currentUser.displayName == user ? <DeleteOutlinedIcon onClick={deleteMessage}className="message__trashIcon" fontSize={"smaller"} 
            color ={'action'}/> : <div />}
        </div>
      
        <p>{messages}</p>
    </div>
    </div>
  )
}

export default Message 